import React from 'react';
import { ArrowRight } from 'lucide-react';
import { HierarchyDiagram } from './HierarchyDiagram';
export function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section id="hero" className="relative pt-32 pb-16 md:pt-40 md:pb-24 overflow-hidden bg-gradient-to-b from-slate-50 to-white" data-id="element-183">
      <div className="container mx-auto px-4 max-w-7xl" data-id="element-184">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-185">
          {/* Content */}
          <div className="space-y-8 text-center lg:text-left" data-id="element-186">
            <div className="inline-flex items-center px-3 py-1 rounded-full bg-indigo-50 text-indigo-700 text-sm font-medium border border-indigo-100 mb-4" data-id="element-187">
              <span className="flex h-2 w-2 rounded-full bg-indigo-600 mr-2" data-id="element-188"></span>
              Now in Beta Access
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-slate-900 leading-[1.1]" data-id="element-189">
              A framework for designing organisations around{' '}
              <span className="text-indigo-600" data-id="element-190">capability</span>, not
              hierarchy.
            </h1>

            <p className="text-lg md:text-xl text-slate-600 max-w-2xl mx-auto lg:mx-0 leading-relaxed" data-id="element-191">
              ATD provides a shared language for reasoning about how skills
              combine, how teams form, and how organisations evolve.
            </p>

            <div className="bg-slate-50 border border-slate-100 rounded-lg p-4 text-left" data-id="element-192">
              <p className="text-sm text-slate-500 font-medium mb-1 uppercase tracking-wide" data-id="element-193">
                The Problem
              </p>
              <p className="text-slate-700" data-id="element-194">
                Most organisations are designed using structures that are easy
                to draw: org charts, job titles, headcount. None of these
                reliably explain what an organisation can actually do or why it
                struggles when things change.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4 pt-4" data-id="element-195">
              <button onClick={() => scrollToSection('waitlist')} className="w-full sm:w-auto bg-primary text-primary-foreground px-8 py-4 rounded-lg font-semibold text-lg hover:opacity-90 transition-all shadow-lg shadow-indigo-500/20 flex items-center justify-center gap-2" data-id="element-196">
                Join the Waitlist
                <ArrowRight className="h-5 w-5" data-id="element-197" />
              </button>

              <button onClick={() => scrollToSection('concepts')} className="w-full sm:w-auto bg-white text-slate-700 border border-slate-200 px-8 py-4 rounded-lg font-semibold text-lg hover:bg-slate-50 hover:border-slate-300 transition-all flex items-center justify-center" data-id="element-198">
                Explore the Framework
              </button>
            </div>

            <div className="pt-8 flex items-center justify-center lg:justify-start gap-8 text-sm text-slate-500" data-id="element-199">
              <div className="flex items-center gap-2" data-id="element-200">
                <div className="w-1 h-1 bg-slate-400 rounded-full" data-id="element-201"></div>
                <span data-id="element-202">Evidence-based</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-203">
                <div className="w-1 h-1 bg-slate-400 rounded-full" data-id="element-204"></div>
                <span data-id="element-205">Scalable structure</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-206">
                <div className="w-1 h-1 bg-slate-400 rounded-full" data-id="element-207"></div>
                <span data-id="element-208">Clear boundaries</span>
              </div>
            </div>
          </div>

          {/* Visual */}
          <div className="relative lg:h-[600px] flex items-center justify-center" data-id="element-209">
            <div className="absolute inset-0 bg-gradient-to-tr from-indigo-50 to-pink-50 rounded-full blur-3xl opacity-60 transform translate-x-10 translate-y-10" data-id="element-210"></div>
            <HierarchyDiagram data-id="element-211" />
          </div>
        </div>
      </div>
    </section>;
}